/**
 * MPP Setups — price vs live MPP - Auto Trendlines (Memory) lines.
 *
 * Scanner columns (`mem_*`) and these shared defs share `computeMemorySetups`.
 * +1 Buy / −1 Sell / 0 none (Box is 1 in-channel / 0 out). See memorySetups.ts.
 */
import type { IndicatorParams, SharedIndicatorDef } from "../types";
import { computeMemorySetups, type MemorySetupPack } from "./memorySetups";

const LABELS = { pos: "Buy", neg: "Sell", zero: "—" } as const;
const BOX_LABELS = { pos: "In", neg: "—", zero: "—" } as const;

function setup(
  id: keyof MemorySetupPack,
  name: string,
  panelKey: string,
  labels: { pos: string; neg: string; zero?: string } = LABELS,
): SharedIndicatorDef {
  return {
    id: `mpp-${id}`,
    label: name,
    group: "Afiat Setups",
    kind: "state",
    format: "state",
    stateLabels: labels,
    params: [],
    panelKey,
    computeSeries: (data, _p: IndicatorParams) => computeMemorySetups(data, _p)[id],
  };
}

export const PULLBACK = setup("pullback", "Afiat - PullBack", "mem_pullback");
export const BREAKOUT = setup("breakout", "Afiat - Breakout", "mem_breakout");
export const BOUNCE = setup("bounce", "Afiat - Bounce", "mem_bounce");
export const BOX = setup("box", "Afiat - Box", "mem_box", BOX_LABELS);
export const TOUCH = setup("touch", "Afiat - Touch", "mem_touch");
export const REVERSAL = setup("reversal", "Afiat - Reversal", "mem_reversal");
export const HEADWIND = setup("headwind", "Afiat - Headwind", "mem_headwind");
export const FLOW = setup("flow", "Afiat - Flow", "mem_flow");

export const PROPRIETARY_INDICATORS: ReadonlyArray<SharedIndicatorDef> = [
  PULLBACK,
  BREAKOUT,
  BOUNCE,
  BOX,
  TOUCH,
  REVERSAL,
  HEADWIND,
  FLOW,
];
